import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { UserModel } from "../models/UserModel";

export interface IAuthState {
  user?: UserModel;
  accessToken?: string;
}

const initialAuthState: IAuthState = {
  user: undefined,
  accessToken: undefined,
};

const authSlice = createSlice({
  name: "auth",
  initialState: initialAuthState,
  reducers: {
    login: (state, action: PayloadAction<{ accessToken: string }>) => {
      state.accessToken = action.payload.accessToken;
      state.user = undefined;
    },
    register: (state, action: PayloadAction<{ accessToken: string }>) => {
      state.accessToken = action.payload.accessToken;
      state.user = undefined;
    },
    logout: (state) => {
      state.user = undefined;
      state.accessToken = undefined;
    },
    setUser: (state, action: PayloadAction<{ user: UserModel }>) => {
      state.user = action.payload.user;
    },
    fulfillUser: (state, action: PayloadAction<{ user: UserModel }>) => {
      state.user = action.payload.user;
    },
  },
});

// Export actions
export const actions = authSlice.actions;

// Legacy action types for backward compatibility
export const actionTypes = {
  Login: authSlice.actions.login.type,
  Logout: authSlice.actions.logout.type,
  Register: authSlice.actions.register.type,
  UserLoaded: authSlice.actions.fulfillUser.type,
  SetUser: authSlice.actions.setUser.type,
};

// Persisted reducer
export const reducer = persistReducer(
  {
    storage,
    key: "v100-demo1-auth",
    whitelist: ["user", "accessToken"],
  },
  authSlice.reducer
);
